<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
              style="height: 45px"
              slot="activator"
              small
              v-on="{ ...tooltip, ...menu }"
              text
              :id="`btn_action_${element.name}`"
              class="mx-0 px-0"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("expSugCommons.label.more") }}</span>
      </v-tooltip>
    </template>
    <v-list dense>
      <v-list-item-group>
        <v-subheader>{{ $t("expSugCommons.tooltip.edition") }}</v-subheader>
        <v-list-item
            :disabled="element.running || element.loading || readOnlyProject"
            class="mx-2"
            @click="$emit('edit', element)"
        >
          <v-list-item-action>
            <v-icon small class="ml-1">mdi-pencil</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("expSugCommons.tooltip.edit") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
            :disabled="element.loading || readOnlyProject"
            class="mx-2"
            @click="$emit('clone', element)"
        >
          <v-list-item-action>
            <v-icon small class="ml-1">mdi-content-copy</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("expSugCommons.tooltip.clone") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
            :disabled="element.running || element.loading || readOnlyProject"
            class="mx-2"
            @click="$emit('delete', element)"
        >
          <v-list-item-action>
            <v-icon small class="ml-1">mdi-delete</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("expSugCommons.tooltip.delete") }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
      <v-list-item-group>
        <v-divider
            v-if="!downloadDisabled || !testDisabled"
            class="mx-5"
        ></v-divider>
        <v-subheader v-if="!downloadDisabled || !testDisabled">{{ $t("expSugCommons.label.actions") }}</v-subheader>
        <v-list-item
            v-if="!downloadDisabled"
            :disabled="element.loading || !element.models || element.models.length === 0"
            class="mx-2"
            @click="$emit('download', element)"
        >
          <v-list-item-action>
            <v-icon small class="ml-1">mdi-download</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("experiments.tooltip.downloadModel") }}</v-list-item-title>
        </v-list-item>
        <v-list-item
            v-if="!testDisabled"
            :disabled="!alwaysTestable && (element.loading || !element.models || element.models.length === 0)"
            class="mx-2"
            @click="$emit('test', element)"
        >
          <v-list-item-action>
            <v-icon small class="ml-1">mdi-eye-check</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t("expSugCommons.tooltip.test") }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: ["element", "downloadDisabled", "alwaysTestable", "disabled", "testDisabled"],
  computed: {
    ...mapGetters(["readOnlyProject"]),
  }
}
</script>